import { bool, func, number, shape, string } from "prop-types"
import { Checkbox } from "components/ui"
import AttendeeDetail from "components/admin/LegacyRegistration/AttendeeDetail"

const AttendeeCheckbox = ({ attendee, checked, onSelect }) => {
  return (
    <div key={attendee.id} className="d-f ai-c jc-sb">
      <Checkbox
        name={`waitlisted_attendee_${attendee.id}`}
        htmlFor={`waitlisted_attendee_${attendee.id}`}
        text={<AttendeeDetail attendee={attendee} />}
        checked={checked}
        onSelect={onSelect}
        disabled={attendee.isCanceled}
      />
      <div>{attendee.isCanceled ? "-" : attendee.totalCostCents === "0" ? "Full" : "Sold out"}</div>
    </div>
  )
}

AttendeeCheckbox.propTypes = {
  attendee: shape({
    id: number,
    totalCostCents: string
  }).isRequired,
  checked: bool.isRequired,
  onSelect: func.isRequired,
  disabled: bool
}

export default AttendeeCheckbox
